import { render } from "./expense-reports.vue?vue&type=template&id=13d6804b"
import script from "./expense-reports.vue?vue&type=script&lang=js"
export * from "./expense-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__